export default function productReducer(state, action) {
  //console.log('STATE  : ', state)
  switch (action.type) {
    case 'GET_ALL_PRODUCTS':
      return {
        ...state,
        products: action.payload,
        loading: false,
        totalPages: action.totalPages,
      }
    case 'ADD_PRODUCT':
      return {
        ...state,
        products: [action.payload, ...state.products],
      }
    case 'EDIT_PRODUCT':
      const updatedProduct = action.payload

      const updatedProducts = state.products.map((product) => {
        if (product._id === updatedProduct._id) {
          return updatedProduct
        }
        return product
      })

      return {
        ...state,
        products: updatedProducts,
      }
    case 'REMOVE_PRODUCT':
      return {
        ...state,
        products: state.products.filter((product) => product._id !== action.payload),
      }
    default:
      return state
  }
}
